import { resolveAPP, rejectAPP } from './type'
import LOGO from './logo'

const schema = 'cardniu://app/webview/share?cb=onShareResult'

const iframeCaller = (url: string) => {
  console.log('[分享 KN]', url)
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  document.body.appendChild(iframe)
  setTimeout(() => {
    (<HTMLElement>iframe.parentNode).removeChild(iframe)
  }, 100)
}

const parseUrl = (url: string, params: { [x: string]: any; }) => {
  const hasQ = url.indexOf('?') !== -1
  const paramsArray = []
  for (const i in params) {
    if (Object.prototype.hasOwnProperty.call(params, i)) {
      paramsArray.push(i + '=' + params[i])
    }
  }
  return url + (hasQ ? '&' : '?') + paramsArray.join('&')
}

const helper = (title: string, content: string, url: string): Promise<resolveAPP | rejectAPP> => {
  return new Promise<resolveAPP | rejectAPP>((resolve: (v: resolveAPP) => void, reject: (v: rejectAPP) => void) => {
    window.onShareResult = (r: any) => {
      console.log('[kn share res]', r)
      const { targetApp, resultCode } = r
      if (+resultCode === 0) {
        resolve(targetApp)
      } else if (+resultCode === 1) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(['error', targetApp])
      } else {
        console.log('取消分享')
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(['cancel', targetApp])
      }
    }
    iframeCaller(parseUrl(schema, {
      title: encodeURIComponent(title),
      content: encodeURIComponent(content),
      url: encodeURIComponent(url),
      share_way: 'link',
      type: '',
      shareChannelType: 1,
      img: LOGO
    }))
  })
}

export default helper
